import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let location_ids = useDataValue({
    context: 'tab',
    path: 'selected.locations',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_ids,
    },
    pause: !location_ids,
    requestPolicy: 'cache-and-network',
  }
}
